module.exports = __webpack_public_path__ + "media/images/happening/logo-macif-9f948ec4ffbdb13b89585435e12d1d58.png";